import { fetch } from '../fetchWrapper/fetch';
import { IMenuLabel, IMenuLabelsResponseBody } from './types';
import { API_URL } from '../constants';

export const getMenuLabels = async (): Promise<IMenuLabel[]> => {
  try {
    const res = await fetch(`${API_URL}/menus/menu-labels`);

    if (!res.ok) throw new Error();

    const { data }: IMenuLabelsResponseBody = await res.json();
    return data;
  } catch (e) {
    throw new Error('Could not fetch menu labels');
  }
};
